import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Fragment } from 'react';
import styled, { css } from 'styled-components';
import DropdownItem from '../../node_modules/reactstrap/esm/DropdownItem.js';
import DropdownMenu$1 from '../../node_modules/reactstrap/esm/DropdownMenu.js';
import DropdownToggle$1 from '../../node_modules/reactstrap/esm/DropdownToggle.js';
import { gold, primaryShadow, primary, blueGrey } from '../../assets/colors.js';
import { Montserrat } from '../../assets/fonts.js';
import handleMailClick from '../HeaderMailModal/handleMailClick.js';
import { capitalize } from '../utils/string.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12;
styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  color: ", ";\n  bottom: -20px;\n  border-bottom: 4px solid;\n  visibility: ", ";\n"])), gold, function (props) {
  return props.visible && "visible" || "hidden";
});
styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  size: 20px;\n  padding: 3px;\n"])));
styled.i.attrs(function (props) {
  return {
    className: "fa fa-2x ".concat(props.open ? "fa-angle-up" : "fa-angle-down", " text-white")
  };
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin: auto;\n"])));
var DropdownToggle = styled(DropdownToggle$1)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  &:focus {\n    outline: 0;\n  }\n"])));
var SignedInBox = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  align-self: center;\n  margin-left: 15px;\n  & span {\n    margin: 0;\n    margin-right: 20px;\n  }\n"])));
styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: absolute;\n  white-space: nowrap;\n  top: 60px;\n  background: white;\n  z-index: 1;\n  right: 0;\n  visibility: ", ";\n  box-shadow: 0 5px 10px 0 ", ";\n"])), function (props) {
  return props.visible && "visible" || "hidden";
}, primaryShadow);
var ActionCss = css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  padding: 15px 30px;\n  color: ", ";\n  text-decoration: none;\n  font-size: 16px;\n  font-family: ", ";\n  font-weight: 600;\n  letter-spacing: -0.13px;\n  line-height: 24px;\n  background: transparent;\n  display: block;\n  height: inherit;\n  width: 100%;\n  white-space: nowrap;\n\n  :hover,\n  .active {\n    border-left: 5px solid ", ";\n    padding-left: 25px;\n    text-decoration: none;\n    color: ", ";\n    font-family: ", ";\n    font-size: 16px;\n    font-weight: 600;\n    letter-spacing: -0.13px;\n    line-height: 24px;\n  }\n"])), function (props) {
  return props.color;
}, Montserrat, gold, primary, Montserrat);
// This was a styled LINK but need router for that
var Action = styled.a.attrs(function (props) {
  return {
    href: props.to
  };
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", ";\n"])), ActionCss);
var EmailAction = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", ";\n  cursor: pointer;\n"])), ActionCss);
var MemberActions = styled.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n  align-content: center;\n"])));
var MemberName = styled.div(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n  white-space: nowrap;\n  margin-bottom: 5px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  @media (max-width: 991px) {\n    font-size: 18px;\n    font-weight: bold;\n  }\n"])), Montserrat, function (props) {
  return props.fs || "12px";
}, function (props) {
  return props.fw || 600;
}, function (props) {
  return props.color || "white";
});
var getDropdownPosition = function getDropdownPosition(_ref) {
  var publicDropdown = _ref.publicDropdown;
  return css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    ", "\n    right: 0 !important;\n    left: auto !important;\n  "])), publicDropdown ? "top: 15px !important;" : "");
};
var DropdownMenu = styled(DropdownMenu$1)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  transform: translate3d(0px, 58px, 0px) !important;\n  &.dropdown-menu.show {\n    ", ";\n    border-radius: 0;\n    box-shadow: 0 5px 10px 0 ", ";\n    margin: 0;\n    padding: 0;\n  }\n  & div.dropdown-divider {\n    margin: 0;\n  }\n"])), getDropdownPosition, primaryShadow);
var UserInfoWrapper = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  padding: 10px 30px;\n"])));
var UserInfo = function UserInfo(_ref2) {
  var _ref2$me = _ref2.me,
    me = _ref2$me === void 0 ? {} : _ref2$me;
  return me.id ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(UserInfoWrapper, null, /*#__PURE__*/React__default.createElement(MemberName, {
    color: primary,
    fs: "16px"
  }, capitalize(me.firstName), " ", capitalize(me.lastName)), /*#__PURE__*/React__default.createElement(MemberName, {
    color: primary,
    fs: "14px",
    fw: "500",
    className: "text-muted mb-0"
  }, "ID: ", me.id)), /*#__PURE__*/React__default.createElement(DropdownItem, {
    divider: true
  })) : null;
};
var DropDown = function DropDown(_ref3) {
  var options = _ref3.options,
    comp = _ref3.comp,
    modalToggle = _ref3.modalToggle,
    meEmailMigrationData = _ref3.meEmailMigrationData,
    setModalType = _ref3.setModalType,
    publicDropdown = _ref3.publicDropdown,
    me = _ref3.me;
  var LinkFrame = comp || Action;
  return /*#__PURE__*/React__default.createElement(DropdownMenu, {
    publicDropdown: publicDropdown
  }, /*#__PURE__*/React__default.createElement(UserInfo, {
    me: me
  }), options && /*#__PURE__*/React__default.createElement(Fragment, null, options.map(function (_ref4) {
    _ref4.id;
      var to = _ref4.to,
      target = _ref4.target,
      _ref4$label = _ref4.label,
      label = _ref4$label === void 0 ? "" : _ref4$label;
    return /*#__PURE__*/React__default.createElement(Fragment, {
      key: label
    }, label.toLowerCase() === "my email" ? /*#__PURE__*/React__default.createElement(EmailAction, {
      onClick: function onClick() {
        return handleMailClick({
          meEmailMigrationData: meEmailMigrationData,
          setModalType: setModalType,
          setOpen: modalToggle
        });
      },
      color: blueGrey
    }, label) : /*#__PURE__*/React__default.createElement(LinkFrame, {
      to: to,
      target: target,
      color: blueGrey
    }, label), /*#__PURE__*/React__default.createElement(DropdownItem, {
      divider: true
    }));
  })), !publicDropdown && /*#__PURE__*/React__default.createElement(LinkFrame, {
    to: "/logout",
    color: blueGrey
  }, "LOGOUT"));
};

export { Action, DropDown, DropdownToggle, EmailAction, MemberActions, MemberName, SignedInBox, UserInfo };
